import styled, { css } from 'styled-components'
import { palette } from 'theme/palette'

const buttonColorChanger = (isPrimaryButton) => isPrimaryButton ? palette.mainBlue : palette.white
const boxShadowChanger = (isPrimaryButton) => isPrimaryButton ? `0 4px 12px ${palette.primaryShadow}` : `0 2px 4px ${palette.secondaryShadow}`
const buttonBorderChanger = (isPrimaryButton) => isPrimaryButton ? `1px solid ${palette.transparent}` : `1px solid ${palette.mainBlue}`

export const ButtonWrapper = styled.div.attrs(() => ({

}))<{ isModalButton: boolean }>`
  padding: ${props => props.isModalButton ? '0 10px' : '0 10px 10px'};
`

export const ButtonContainer = styled.a<{ isButtonDisabled: boolean, isPrimaryButton: boolean, hasIcon: any }>`
  padding: ${props => props.hasIcon ? '6px 0' : '10px 0'};
  background-color: ${props => props.isButtonDisabled ? `${palette.disabledElement}` : buttonColorChanger(props.isPrimaryButton)};
  border-radius: 12px;
  border: ${props => props.isButtonDisabled ? `1px solid ${palette.transparent}` : buttonBorderChanger(props.isPrimaryButton)};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => props.isButtonDisabled ? 'auto' : 'pointer'};
  box-shadow: ${props => props.isButtonDisabled ? 'none' : boxShadowChanger(props.isPrimaryButton)};
  user-select: ${props => props.isButtonDisabled ? 'none' : 'auto'};
  text-decoration: none;
  box-sizing: border-box;
  pointer-events: ${props => props.isButtonDisabled ? 'none' : 'auto'};
  height: 44px;
  
  ${props => !props.isButtonDisabled && css`
    @media (hover: hover) {
      &:hover {
        box-shadow: ${props.isPrimaryButton ? `0 4px 16px ${palette.primaryHoverShadow}` : 'none'};
        background-color: ${props.isPrimaryButton ? `${palette.primaryHoverState}` : `${palette.secondaryHoverState}`};
        border: ${props.isPrimaryButton ? '1px solid transparent' : `1px solid ${palette.mainBlue}`};
      }
    }

    &:active {
      background-color: ${props.isPrimaryButton ? `${palette.primaryClickState}` : `${palette.secondaryClickState}`};
      box-shadow: none;
    }
    
    &:focus-visible {
      outline: 2px solid ${palette.mainBlue};
    }
  `}
`

export const ButtonTitle = styled.span<{ isButtonDisabled: boolean, isPrimaryButton: boolean }>`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${props => props.isButtonDisabled ? `${palette.mediumGray}` : buttonColorChanger(!props.isPrimaryButton)}; 
`

export const IconWrapper = styled.div`
  margin-right: 10px;
  height: 32px;
`
